let _lastTimestamp = 0; //上传时间增量
let _lastLoaded = 0; //上传进度增量
let _data = {};
let _inputEle = null;
var file = null;

// 上传配置项
let uploadOption = {
  action: "http://localhost/upload", //上传接口
  filter: "", //文件类型过滤器
  maxsize: 50, //文件上传大小限制，单位：M
  params: null, //请求参数
  beforeUploadCallback: null,
  startCallback: null, //开始上传的回调函数
  progressCallback: null, //上传进度回调函数
  successCallback: null, //上传成功回调函数
  errorCallback: null //上传错误的回调函数
};

//配置方法
let config = (action, params, filter, maxsize, startcb) => {
  if (action != null && action != "") {
    uploadOption.action = action;
  }
  if (filter != null) {
    uploadOption.filter = filter;
  }
  if (maxsize != null && !isNaN(maxsize)) {
    uploadOption.maxsize = maxsize;
  }
  if (params != null) {
    uploadOption.params = params;
  }
  uploadOption.startCallback = startcb;
};

//设置配置对象，建议使用
let setOption = opt => {
  if (opt != undefined && opt != null) {
    uploadOption.action = opt.action;
    uploadOption.filter = opt.filter || "";
    uploadOption.maxsize = opt.maxsize || 50;
    uploadOption.params = opt.params || null;
    uploadOption.beforeUploadCallback = opt.beforeUploadCallback || null;
    uploadOption.startCallback = opt.startCallback || null;
    uploadOption.progressCallback = opt.progressCallback || null;
    uploadOption.successCallback = opt.successCallback || null;
    uploadOption.errorCallback = opt.errorCallback || null;
  }
};

// 选择文件方法
let selectFile = cb => {
  _inputEle = document.createElement("input");
  _inputEle.type = "file";
  _inputEle.multiple = "multiple";
  _inputEle.accept =
    ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";
  _inputEle.click();
  _inputEle.onchange = function () {
    file = _inputEle.files[0];
    let tmparr = file.name.split(".");
    let fileType = tmparr[tmparr.length - 1].toLowerCase();
    if (uploadOption.filter != null && uploadOption.filter != "") {
      let filterArr = uploadOption.filter.split(",");
      let notFilter = true;
      for (let i = 0; i < filterArr.length; i++) {
        if (fileType == filterArr[i].toLowerCase()) {
          notFilter = false;
          break;
        }
      }

      if (notFilter) {
        //文件类型不符合要求
        if (
          uploadOption.errorCallback != undefined &&
          uploadOption.errorCallback != null
        ) {
          uploadOption.errorCallback("File type does not meet requirements");
        }
        return;
      }
    }
    let sizeM = file.size / 1024 / 1024;
    if (sizeM > uploadOption.maxsize) {
      if (
        uploadOption.errorCallback != undefined &&
        uploadOption.errorCallback != null
      ) {
        uploadOption.errorCallback("File size does not meet requirements");
      }
      return;
    }
    cb(file);
  };
};

let removeFile = () => {
  if (file) {
    file = null;
  }
};

//上传方法
let upload = (resolve, reject) => {
  if (file == null || file == undefined) {
    alert("Plase select file!");
    return;
  }
  if (
    uploadOption.beforeUploadCallback != null &&
    uploadOption.beforeUploadCallback != undefined
  ) {
    try {
      let res = uploadOption.beforeUploadCallback(file);
      res.then(data => {
        _data = {
          importNo: data.importNo,
          ...data.tokenResult
        };
        var formData = new FormData();
        if (uploadOption.params != null) {
          for (let key in uploadOption.params) {
            formData.append(key, uploadOption.params[key]);
          }
        }
        formData.append("Filename", file.name);
        formData.append("key", _data.objectKey);
        formData.append("OSSAccessKeyId", _data.accessId);
        formData.append("policy", _data.policy); //policy
        formData.append("Signature", _data.signature); //签名
        formData.append("callback", _data.callback);
        formData.append("file", file);
        formData.append("success_action_status", "200"); //成功后返回的操作码

        var _url = _data.host;
        var xhr = new XMLHttpRequest();
        var action = _url || uploadOption.action;
        xhr.open("POST", action);

        // ****** event Listenter ******
        //upload start
        xhr.upload.onloadstart = function (event) {
          _lastTimestamp = event.timeStamp;
          _lastLoaded = 0;
          if (
            uploadOption.startCallback != undefined &&
            uploadOption.startCallback != null
          ) {
            uploadOption.startCallback(file);
          }
        };
        //upload progress
        xhr.upload.onprogress = function (event) {
          var offtimestamp = event.timeStamp - _lastTimestamp;
          _lastTimestamp = event.timeStamp;
          var offloaded = event.loaded - _lastLoaded;
          _lastLoaded = event.loaded;
          offtimestamp = offtimestamp / 1000; //转换成秒
          offloaded = offloaded / 1024; //转换成KB
          var speed = Math.round(offloaded / offtimestamp); // KB/S
          var progress = event.loaded / event.total; // 0~1
          var total = Math.round(event.total / 1024); // KB
          if (
            uploadOption.progressCallback != undefined &&
            uploadOption.progressCallback != null
          ) {
            uploadOption.progressCallback({
              computable: event.lengthComputable,
              speed: speed,
              progress: progress,
              total: total,
              event: event
            });
          }
        };
        //upload done
        xhr.onload = function (event) {
          if (
            uploadOption.successCallback != undefined &&
            uploadOption.successCallback != null
          ) {
            var resultObj;
            try {
              resultObj = JSON.parse(xhr.responseText);
            } catch (error) {
              resultObj = xhr.responseText;
            }
            uploadOption.successCallback(resultObj);
            file = null;
          }
        };
        //upload error
        xhr.onerror = function (event) {
          if (
            uploadOption.errorCallback != undefined &&
            uploadOption.errorCallback != null
          ) {
            uploadOption.errorCallback();
          }
        };
        //upload status change
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4) {
            if (xhr.status == 200) {
              try {
                var resultObj = JSON.parse(xhr.responseText);
                resolve(resultObj);
              } catch (error) {
                resolve(xhr.responseText);
              }
            }
          }
        };
        xhr.send(formData);
      });
    } catch (error) {
      console.log("ajax error");
    }
  } else {
    console.log("Cannot upload without selecting files");
  }
};

let uploadPr = () => {
  return new Promise(upload);
};

export let uploader = {
  config,
  setOption,
  upload: uploadPr,
  selectFile,
  removeFile
};
